import styled from 'styled-components';

import { colors } from 'theme/colors';

export const WrapperWithOffset = styled.div`
  margin: 60px auto;
`;

export const SecondaryContainer = styled.div`
  background-color: ${colors.legacy.grey[400]};
  height: 100vh;
  overflow: auto;
  width: 100%;
`;

export const FullHeightWrapper = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
`;
